<template>
  <router-view />
</template>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  color: #3f5171;
  font-size: 12px;
  line-height: 1;
}
#app {
  height: 1px;
  min-height: 100%;
}
h1 {
  font-weight: bold;
  font-size: 22px;
}
p {
  font-size: 14px;
  line-height: 21px;
}
a,
a:active,
a:visited {
  text-decoration: none;
}
</style>
